import { Directive } from '@angular/core'

@Directive({
    selector: '[tidyCard]',
    standalone: false
})
export class TidyCardDirective {}
